import React,{useRef,useEffect} from 'react';
import {css} from "emotion";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import validation from '../../../image/icon/icon-simple/validation.png'


const ModalValid = (props) =>{
  const refModal = useRef(null);

  useEffect(()=>{
    disableBodyScroll(refModal);
      return () =>{
        clearAllBodyScrollLocks();
      }
  },[])

  return(
    <div ref={refModal} className={css`top:0px;left:0px;position:fixed;z-index:100;width:100%;height:100%;background-color:rgba(0, 0, 0,0.5);display:flex;align-items:center;justify-content:center`}>
        <div className={css`padding-bottom:10px;overflow:hidden;background-color:white;border-radius:10px;width:300px;height:200px;display:flex;flex-direction:column;align-items:center`}>
          <div className={css`flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center`}>  <img className={css`width:80px;`}  src={validation}/>
            <div className={css`margin-top:10px;color:#3f4d6e;`}>
            {props.message.split ('\n'). map (function (item, key) {
                return (
                  <span className={css`&:nth-child(2){margin-top:10px}`} key = {key}>
                    {item}
                    <br/>
                  </span>
                )
              })}</div>
            </div>
              <div className={css`height:40px;display:flex;flex-direction:row;justify-content:center;align-items:center;width:100%;box-sizing:border-box;padding-left:20px;padding-right:20px`}>
                    <div  onClick={props.onClose}  className={css`padding-left:5px;padding-right:5px;display:inline-blokc;cursor:pointer;font-weight:600;text-align:center;color:#4680B3;height:30px;line-height:30px;font-size:14px;&:hover{background-color:rgba(70, 128, 179,0.1)}`}>OK</div>
                  </div>
          </div>
    </div>
  )
}

export default ModalValid;
